/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */

import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import { ClassNames } from '../../../utils/dom/css-classes';
import Request, { ApiMode } from '../../../utils/request';
import EventHandler from '../../../utils/dom/event-handler';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import Modal from '../../../components/Modal';

const SELECTOR_WRAPPER = '.p-my-cpd-plan-do--review';
const SELECTOR_MODAL = '.js-my-cpd-plan-do--review-modal';

const SELECTOR_SPLASH = '.p-my-cpd-plan-do--review-splash';
const SELECTOR_SPLASH_NEXT = '.p-my-cpd-plan-do--review-splash-next';

const SELECTOR_STEP = '.p-my-cpd-plan-do--review-step';
const SELECTOR_QUESTION = '.p-my-cpd-plan-do--review-questions';

const SELECTOR_EXIT_BUTTON = '.js-exit-my-cpd-plan-do--review';

const SELECTOR_SUCCESS_WRAPPER = '.confirmation-pdr-page';
const SELECTOR_SUCCESS_BTN = '.return-to-home-btn';
const LOADER_PDR_WRAPPER = '.loader-wrapper-pdr';

const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-my-cpd-plan-do--review-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-my-cpd-plan-do--review-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-my-cpd-plan-do--review-confirm-no';

const IS_LOCAL = false;
const HIDDEN_CLASS = 'u-hidden';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';
class MyCPDPlanDoReview {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();

		this.splash = SelectorEngine.findOne(SELECTOR_SPLASH, this._wrapper);
		this.splashNext = SelectorEngine.findOne(SELECTOR_SPLASH_NEXT, this.splash);

		this.errorContainer = SelectorEngine.findOne('.p-my-cpd-plan-do--review-error-container', this._wrapper);
		this.errorText = SelectorEngine.findOne('.error-text', this.errorContainer);
		this.closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this.errorContainer);

		this.step = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.loader = SelectorEngine.findOne(LOADER_PDR_WRAPPER, this._wrapper);
		this.questions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.confirm_success_loading = SelectorEngine.findOne(SELECTOR_SUCCESS_WRAPPER, this._wrapper); // success loading warapper
		this.confirm_success_show_btn = SelectorEngine.findOne(SELECTOR_SUCCESS_BTN, this._wrapper); // return to cpd home btn wrapper

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.closeErrorSnackBar.addEventListener('click', () => {
			window.location.reload();
		});

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.splashNext, Events.Click, () => {
			this.fetchSteps();
		});
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	async fetchSteps() {
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/coachdetails/getplandoreviewform';

			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	showSuccessPage() {
		this.splash.classList.add(HIDDEN_CLASS);
		this.confirm_success_show_btn.classList.remove(HIDDEN_CLASS);
		this.loader.classList.add(HIDDEN_CLASS);
	}

	showErrorContainer(errorMessage) {
		this.splash.classList.add(HIDDEN_CLASS);
		this.confirm_success_show_btn.classList.add(HIDDEN_CLASS);
		this.loader.classList.add(HIDDEN_CLASS);
		this.confirm_success_loading.classList.add(HIDDEN_CLASS);
		this.loader.classList.add(HIDDEN_CLASS);
		this.step.classList.remove(HIDDEN_CLASS);
		this.errorContainer.classList.remove(HIDDEN_CLASS);
		this.errorText.innerHTML = errorMessage;
		this.errorContainer.scrollIntoView();
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	showlaodingSection() {
		this.confirm_success_loading.classList.remove(HIDDEN_CLASS);
		this.loader.classList.remove(HIDDEN_CLASS);
		this.step.classList.add(HIDDEN_CLASS);
	}

	initiateFormGenerator(stepsData) {
		this.splash.classList.add(ClassNames.Hidden);
		this.step.classList.remove(ClassNames.Hidden);

		this.formGenerator = new FormGenerator(this.questions, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			radioAnswerField: 'id',
			isBackButtonEnabled: true,
			isHideProgress: false,
			mainPageElement: this.step,
			submitButton : {
				title: 'Get recommendations'
			},
			backButtonHandlerFirstStep: () => {
				this.splash.classList.remove(ClassNames.Hidden);
				this.step.classList.add(ClassNames.Hidden);
			}
		});

		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
			this.savePlanDoReviewForm(this.answerList);
		});

		EventHandler.on(this.AddWorkCardConfirmButton, Events.Click, () => {
			const isFormValid = this.formGenerator.formValidation();
			if (isFormValid) {
				console.log('Answers :', this.answerList);
				this.savePlanDoReviewForm(this.answerList);
			}
		});
	}

	async savePlanDoReviewForm(requestObject) {
		let temporaryArrayIntrest = [];
		temporaryArrayIntrest = requestObject?.subjectAreas.map((item) => item.id);
		const payload = {
			yourLearning: { helpfulLearningFeedback: requestObject.study, learnMoreAboutFeedback: requestObject.subjectArea },
			yourInterest: temporaryArrayIntrest,
			yourFuture: { suggestedLearningArea: requestObject.learning }
		};
		try {
			const url = '/api/coachdetails/plandoreview';
			this.showlaodingSection();
			const apiResponse = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { error, response } = apiResponse;
			stopLoadingAnimation();
			if (error.errorCode == '00') {
				this.showSuccessPage();
			} else {
				this.showErrorContainer(response.message);
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalMyCPDPlanDoReview = new MyCPDPlanDoReview();
export default globalMyCPDPlanDoReview;
